import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import get from 'lodash/get';
import { canUseDOM } from './canUseDOM';

const PrefetchImages = ({ mobileImageArray, desktopImageArray }) => {
  const mobile = useMediaQuery('(max-width:767px)');
  const tablet = useMediaQuery('(min-width:768px) and (max-width:1023px)');
  const largeDesktop = useMediaQuery(
    '(min-width:1024px) and (max-width:1680px)'
  );
  const xlargeDesktop = useMediaQuery('(min-width:1681px)');
  const pixelRatio = canUseDOM && window && window.devicePixelRatio;

  return null;

  if (mobile) {
    if (pixelRatio >= 2) {
      return (
        <div
          className="preloadImages"
          style={{
            backgroundImage:
              mobileImageArray &&
              mobileImageArray.length > 0 &&
              mobileImageArray.map(item => `url(${get(item, 'small2x', '')})`),
          }}
        ></div>
      );
    }
    return (
      <div
        className="preloadImages"
        style={{
          backgroundImage:
            mobileImageArray &&
            mobileImageArray.length > 0 &&
            mobileImageArray.map(item => `url(${get(item, 'small', '')})`),
        }}
      ></div>
    );
  } else if (tablet) {
    if (pixelRatio >= 2) {
      return (
        <div
          className="preloadImages"
          style={{
            backgroundImage:
              desktopImageArray &&
              desktopImageArray.length > 0 &&
              desktopImageArray.map(
                item => `url(${get(item, 'medium2x', '')})`
              ),
          }}
        ></div>
      );
    }
    return (
      <div
        className="preloadImages"
        style={{
          backgroundImage:
            desktopImageArray &&
            desktopImageArray.length > 0 &&
            desktopImageArray.map(item => `url(${get(item, 'medium', '')})`),
        }}
      ></div>
    );
  } else if (largeDesktop) {
    if (pixelRatio >= 2) {
      return (
        <div
          className="preloadImages"
          style={{
            backgroundImage:
              desktopImageArray &&
              desktopImageArray.length > 0 &&
              desktopImageArray.map(item => `url(${get(item, 'large2x', '')})`),
          }}
        ></div>
      );
    }
    return (
      <div
        className="preloadImages"
        style={{
          backgroundImage:
            desktopImageArray &&
            desktopImageArray.length > 0 &&
            desktopImageArray.map(item => `url(${get(item, 'large', '')})`),
        }}
      ></div>
    );
  } else if (xlargeDesktop) {
    if (pixelRatio >= 2) {
      return (
        <div
          className="preloadImages"
          style={{
            backgroundImage:
              desktopImageArray &&
              desktopImageArray.length > 0 &&
              desktopImageArray.map(
                item => `url(${get(item, 'xLarge2x', '')})`
              ),
          }}
        ></div>
      );
    }
    return (
      <div
        className="preloadImages"
        style={{
          backgroundImage:
            desktopImageArray &&
            desktopImageArray.length > 0 &&
            desktopImageArray.map(item => `url(${get(item, 'xLarge', '')})`),
        }}
      ></div>
    );
  } else {
    return '';
  }
};

export default PrefetchImages;
